import React from 'react'

function FooterSimple() {
  return (
    <footer className="navbar footerbar footerbar-minimal">
      <div className="container py-3 text-center">
        <span className="footer-text text-muted small">
          Redi Platforms, LLC
        </span>
      </div>
    </footer>
  )
}

export default FooterSimple
